<div *ngIf="showAllHistory" class="history_container">

    <ng-container *ngFor="let categ of filteredCategories">
        <div
            class="history_table_head blackBgg">
            {{categ.name}}
        </div>


        <swiper [config]="config" [virtual]="true" class="my-swiper">
            <ng-template swiperSlide *ngFor="let program of getProgramsByCategory(categ.id)">
                <div class="table_content">
                    <div class="left_head">
                        <div class="program_name">Title</div>
                        <div class="program_name center_head">Started</div>
                        <div class="program_name center_head">Completed</div>
                        <div class="program_name center_head">Time Spent</div>
                        <div class="program_name center_head">Length</div>
                        <div class="program_name center_head">Sections</div>
                        <div class="program_name center_head">Difficulty</div>
                        <div class="program_name center_head">Layers</div>
                        <div class="program_name">Status</div>
                    </div>

                    <div class="right_head">
                        <div class="program_details prog_name">{{ program.name }}</div>
                        <div class="program_details date center_col">{{ program.startedAt?.toDate() | date:
                            "MM/dd/yy" }}</div>
                        <div class="program_details date center_col"> <span *ngIf="program.completedAt"> {{
                                program.completedAt?.toDate() | date: "MM/dd/yy" }}</span></div>
                        <div class="program_details center_col">
                            <span *ngIf="program.completedAt">
                                {{ getTimeToComplete(program.startedAt?.toDate(), program.completedAt?.toDate()) }}
                            </span>

                        </div>
                        <div class="program_details center_col">
                            <div class="card_footerIcn">
                                <img src="../../assets/images/Time Circle.svg" alt="">
                            </div>
                            <div class="card_footer_sub_head">
                                {{ getLearningHrs(program.totalLearningHrs) }}
                            </div>
                        </div>

                        <div class="program_details center_col">
                            <div class="card_footerIcn">
                                <img src="../../assets/images/Category.svg" alt="">
                            </div>
                            <div class="card_footer_sub_head" *ngIf="program.numberOfSections; else getNumSections">
                                {{ program.numberOfSections }}
                            </div>
                            <ng-template #getNumSections>
                                {{ getTotalNumberOfSections(program.sections) }}
                            </ng-template>
                        </div>

                        <div class="program_details center_col">
                            <div class="level_easy" *ngIf="program.difficultyLevel">
                                <span class="first colored"></span>
                                <span class="second colored"
                                    *ngIf="program.difficultyLevel === 'medium' || program.difficultyLevel === 'hard'; else easyDifficulty"></span>
                                <ng-template #easyDifficulty>
                                    <span class="second transparent"></span>
                                </ng-template>
                                <span class="third colored"
                                    *ngIf="program.difficultyLevel === 'hard'; else notHardDifficulty"></span>
                                <ng-template #notHardDifficulty>
                                    <span class="third transparent"></span>
                                </ng-template>
                            </div>
                            <div class="level_easy" *ngIf="!program.difficultyLevel">
                                <span class="first colored"></span>
                                <span class="second colored"></span>
                                <span class="third transparent"></span>
                            </div>
                        </div>
                        <div class="program_details center_col">
                            1
                        </div>
                        <div class="program_details complete_col">
                            <span class="completeBtn_green" *ngIf="program.progress !== 100">
                                In Progress
                            </span>
                            <span class="completeBtn" *ngIf="program.progress === 100">
                                Complete
                            </span>
                        </div>
                    </div>
                </div>
            </ng-template>

            <!-- <ng-template swiperSlide *ngFor="let program of programs">
            <div class="table_content">
                <div class="left_head">
                    <div class="program_name">Title</div>
                    <div class="program_name center_head">Started</div>
                    <div class="program_name center_head">Completed</div>
                    <div class="program_name center_head">Time Spent</div>
                    <div class="program_name center_head">Length</div>
                    <div class="program_name center_head">Sections</div>
                    <div class="program_name center_head">Difficulty</div>
                    <div class="program_name center_head">Layers</div>
                    <div class="program_name">Status</div>
                </div>

                <div class="right_head">
                    <div class="program_details prog_name">{{ program.name }}</div>
                    <div class="program_details date center_col"><span *ngIf="program.startedAt"> {{
                            program.startedAt?.toDate() | date: "MM/dd/yy" }}</span></div>
                    <div class="program_details date center_col"> <span *ngIf="program.completedAt"> {{
                            program.completedAt?.toDate() | date: "MM/dd/yy" }}</span></div>
                    <div class="program_details center_col">
                        <span *ngIf="program.completedAt">
                            {{ getTimeToComplete(program.startedAt?.toDate(), program.completedAt?.toDate()) }}
                        </span>

                    </div>
                    <div class="program_details center_col">
                        <div class="card_footerIcn">
                            <img src="../../assets/images/Time Circle.svg" alt="">
                        </div>
                        <div class="card_footer_sub_head">
                            {{ getLearningHrs(program.totalLearningHrs) }}
                        </div>
                    </div>

                    <div class="program_details center_col">
                        <div class="card_footerIcn">
                            <img src="../../assets/images/Category.svg" alt="">
                        </div>
                        <div class="card_footer_sub_head">
                            {{ getTotalNumberOfSections(program.sections) }}
                        </div>
                    </div>

                    <div class="program_details center_col">
                        <div class="level_easy">
                            <span class="first colored"></span>
                            <span class="second colored"></span>
                            <span class="third transparent"></span>
                        </div>
                    </div>
                    <div class="program_details center_col">
                        1
                    </div>
                    <div class="program_details complete_col">
                        <span class="completeBtn_green" *ngIf="program.progress !== 100">
                            In Progress
                        </span>
                        <span class="completeBtn" *ngIf="program.progress === 100">
                            Complete
                        </span>
                    </div>
                </div>
            </div>
        </ng-template> -->


        </swiper>
    </ng-container>

</div>

<!-- <div *ngIf="showAllHistory" class="history_container">
    <div class="history_table_head">
        Management / Leadership
    </div>

    <swiper [config]="config" [virtual]="true" class="my-swiper">
        <ng-template swiperSlide>
            <div class="table_content">
                <div class="left_head">
                    <div class="program_name">Title</div>
                    <div class="program_name center_head">Started</div>
                    <div class="program_name center_head">Completed</div>
                    <div class="program_name center_head">Time Spent</div>
                    <div class="program_name center_head">Length</div>
                    <div class="program_name center_head">Sections</div>
                    <div class="program_name center_head">Difficulty</div>
                    <div class="program_name center_head">Layers</div>
                    <div class="program_name">Status</div>
                </div>

                <div class="right_head">
                    <div class="program_details prog_name" style="height: 32px !important; max-height: 32px !important">
                        Instructions and Clear Expectations</div>
                    <div class="program_details date center_col">02/28/23</div>
                    <div class="program_details date center_col">02/30/23</div>
                    <div class="program_details center_col">2 Days</div>

                    <div class="program_details center_col">

                        <div class="card_footerIcn">
                            <img src="../../assets/images/Time Circle.svg" alt="">
                        </div>
                        <div class="card_footer_sub_head">
                            10
                        </div>

                    </div>

                    <div class="program_details center_col">
                        <div class="card_footerIcn">
                            <img src="../../assets/images/Category.svg" alt="">
                        </div>
                        <div class="card_footer_sub_head">
                            2
                        </div>
                    </div>

                    <div class="program_details center_col">
                        <div class="level_easy">
                            <span class="first colored"></span>
                            <span class="second colored"></span>
                            <span class="third transparent"></span>
                        </div>
                    </div>
                    <div class="program_details center_col">1</div>
                    <div class="program_details complete_col"><span class="completeBtn">Complete</span>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template swiperSlide>
            <div class="table_content">
                <div class="left_head">
                    <div class="program_name">Title</div>
                    <div class="program_name center_head">Started</div>
                    <div class="program_name center_head">Completed</div>
                    <div class="program_name center_head">Time Spent</div>
                    <div class="program_name center_head">Length</div>
                    <div class="program_name center_head">Sections</div>
                    <div class="program_name center_head">Difficulty</div>
                    <div class="program_name center_head">Layers</div>
                    <div class="program_name">Status</div>
                </div>

                <div class="right_head">
                    <div class="program_details prog_name" style="height: 32px !important; max-height: 32px !important">
                        The Pathway to Director</div>
                    <div class="program_details date center_col">02/28/23</div>
                    <div class="program_details date center_col">02/30/23</div>
                    <div class="program_details center_col">2 Days</div>
                    <div class="program_details center_col ">

                        <div class="card_footerIcn">
                            <img src="../../assets/images/Time Circle.svg" alt="">
                        </div>
                        <div class="card_footer_sub_head">
                            6
                        </div>
                    </div>

                    <div class="program_details center_col">
                        <div class="card_footerIcn">
                            <img src="../../assets/images/Category.svg" alt="">
                        </div>
                        <div class="card_footer_sub_head">
                            2
                        </div>
                    </div>
                    <div class="program_details center_col">
                        <div class="level_easy">
                            <span class="first colored"></span>
                            <span class="second colored"></span>
                            <span class="third transparent"></span>
                        </div>
                    </div>
                    <div class="program_details center_col">1</div>
                    <div class="program_details complete_col"><span class="completeBtn">Complete</span>
                    </div>
                </div>
            </div>
        </ng-template>


    </swiper>


</div> -->

<div *ngIf="showCompletedHistory">
    <div *ngIf="showCompletedHistory" class="history_container">

        <ng-container *ngFor="let categ of filteredCategories">
            <div
                class="history_table_head blackBgg">
                {{categ.name}}
            </div>
            <swiper [config]="config" [virtual]="true" class="my-swiper">
                <ng-template swiperSlide *ngFor="let program of getCompletedProgramsByCategory(categ.id)">
                    <ng-container>
                        <div class="table_content">
                            <div class="left_head">
                                <div class="program_name">Title</div>
                                <div class="program_name center_head">Started</div>
                                <div class="program_name center_head">Completed</div>
                                <div class="program_name center_head">Time Spent</div>
                                <div class="program_name center_head">Length</div>
                                <div class="program_name center_head">Sections</div>
                                <div class="program_name center_head">Difficulty</div>
                                <div class="program_name center_head">Layers</div>
                                <div class="program_name">Status</div>
                            </div>

                            <div class="right_head">

                                <div class="program_details prog_name">{{ program.name }}</div>
                                <div class="program_details date center_col">{{ program.startedAt?.toDate() | date:
                                    "MM/dd/yy" }}
                                </div>
                                <div class="program_details date center_col">
                                    <span *ngIf="program.completedAt">
                                        {{ program.completedAt?.toDate() | date: "MM/dd/yy" }}
                                    </span>
                                </div>

                                <div class="program_details center_col">
                                    <span *ngIf="program.completedAt">
                                        {{ getTimeToComplete(program.startedAt?.toDate(), program.completedAt?.toDate())
                                        }}
                                    </span>
                                </div>
                                <div class="program_details center_col">
                                    <div class="card_footerIcn">
                                        <img src="../../assets/images/Time Circle.svg" alt="">
                                    </div>
                                    <div class="card_footer_sub_head">
                                        {{ getLearningHrs(program.totalLearningHrs) }}
                                    </div>
                                </div>

                                <div class="program_details center_col">
                                    <div class="card_footerIcn">
                                        <img src="../../assets/images/Category.svg" alt="">
                                    </div>
                                    <div class="card_footer_sub_head"
                                        *ngIf="program.numberOfSections; else getNumSections">
                                        {{ program.numberOfSections }}
                                    </div>
                                    <ng-template #getNumSections>
                                        {{ getTotalNumberOfSections(program.sections) }}
                                    </ng-template>
                                </div>

                                <div class="program_details center_col">
                                    <div class="level_easy" *ngIf="program.difficultyLevel">
                                        <span class="first colored"></span>
                                        <span class="second colored"
                                            *ngIf="program.difficultyLevel === 'medium' || program.difficultyLevel === 'hard'; else easyDifficulty"></span>
                                        <ng-template #easyDifficulty>
                                            <span class="second transparent"></span>
                                        </ng-template>
                                        <span class="third colored"
                                            *ngIf="program.difficultyLevel === 'hard'; else notHardDifficulty"></span>
                                        <ng-template #notHardDifficulty>
                                            <span class="third transparent"></span>
                                        </ng-template>
                                    </div>
                                    <div class="level_easy" *ngIf="!program.difficultyLevel">
                                        <span class="first colored"></span>
                                        <span class="second colored"></span>
                                        <span class="third transparent"></span>
                                    </div>
                                </div>
                                <div class="program_details center_col">
                                    1
                                </div>
                                <div class="program_details complete_col">
                                    <span class="completeBtn">
                                        Complete
                                    </span>
                                </div>
                                <!-- </ng-container> -->
                            </div>
                        </div>
                    </ng-container>
                </ng-template>

                <!-- <ng-container *ngFor="let program of programs">
                <ng-template swiperSlide *ngIf="program.progress === 100">
                    <div class="table_content">
                        <div class="left_head">
                            <div class="program_name">Title</div>
                            <div class="program_name center_head">Started</div>
                            <div class="program_name center_head">Completed</div>
                            <div class="program_name center_head">Time Spent</div>
                            <div class="program_name center_head">Length</div>
                            <div class="program_name center_head">Sections</div>
                            <div class="program_name center_head">Difficulty</div>
                            <div class="program_name center_head">Layers</div>
                            <div class="program_name">Status</div>
                        </div>

                        <div class="right_head">
                            <div class="program_details prog_name">{{ program.name }}</div>
                            <div class="program_details date center_col">{{ program.startedAt?.toDate() | date:
                                "MM/dd/yy" }}
                            </div>
                            <div class="program_details date center_col">
                                <span *ngIf="program.completedAt">
                                    {{ program.completedAt?.toDate() | date: "MM/dd/yy" }}
                                </span>
                            </div>

                            <div class="program_details center_col">
                                <span *ngIf="program.completedAt">
                                    {{ getTimeToComplete(program.startedAt?.toDate(), program.completedAt?.toDate())
                                    }}
                                </span>

                            </div>
                            <div class="program_details center_col">
                                <div class="card_footerIcn">
                                    <img src="../../assets/images/Time Circle.svg" alt="">
                                </div>
                                <div class="card_footer_sub_head">
                                    {{ getLearningHrs(program.totalLearningHrs) }}
                                </div>

                            </div>

                            <div class="program_details center_col">
                                <div class="card_footerIcn">
                                    <img src="../../assets/images/Category.svg" alt="">
                                </div>
                                <div class="card_footer_sub_head">
                                    {{ getTotalNumberOfSections(program.sections) }}
                                </div>
                            </div>

                            <div class="program_details center_col">
                                <div class="level_easy">
                                    <span class="first colored"></span>
                                    <span class="second colored"></span>
                                    <span class="third transparent"></span>
                                </div>
                            </div>
                            <div class="program_details center_col">
                                1
                            </div>
                            <div class="program_details complete_col">
                                <span class="completeBtn">
                                    Complete
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container> -->





            </swiper>
        </ng-container>
    </div>

    <!-- <div class="history_container">
        <div class="history_table_head">
            Management / Leadership
        </div>

        <swiper [config]="config" [virtual]="true" class="my-swiper">
            <ng-template swiperSlide>
                <div class="table_content">
                    <div class="left_head">
                        <div class="program_name">Title</div>
                        <div class="program_name center_head">Started</div>
                        <div class="program_name center_head">Completed</div>
                        <div class="program_name center_head">Time Spent</div>
                        <div class="program_name center_head">Length</div>
                        <div class="program_name center_head">Sections</div>
                        <div class="program_name center_head">Difficulty</div>
                        <div class="program_name center_head">Layers</div>
                        <div class="program_name">Status</div>
                    </div>

                    <div class="right_head">
                        <div class="program_details prog_name"
                            style="height: 32px !important; max-height: 32px !important">Instructions and Clear
                            Expectations</div>
                        <div class="program_details date center_col">02/28/23</div>
                        <div class="program_details date center_col">02/30/23</div>
                        <div class="program_details date center_col">2 Days</div>

                        <div class="program_details center_col ">

                            <div class="card_footerIcn">
                                <img src="../../assets/images/Time Circle.svg" alt="">
                            </div>
                            <div class="card_footer_sub_head">
                                10
                            </div>
                        </div>
                        <div class="program_details center_col">
                            <div class="card_footerIcn">
                                <img src="../../assets/images/Category.svg" alt="">
                            </div>
                            <div class="card_footer_sub_head">
                                2
                            </div>
                        </div>
                        <div class="program_details date center_col">
                            <div class="level_easy">
                                <span class="first colored"></span>
                                <span class="second colored"></span>
                                <span class="third transparent"></span>
                            </div>
                        </div>
                        <div class="program_details date center_col">1</div>
                        <div class="program_details complete_col"><span class="completeBtn">Complete</span>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template swiperSlide>
                <div class="table_content">
                    <div class="left_head">
                        <div class="program_name">Title</div>
                        <div class="program_name center_head">Started</div>
                        <div class="program_name center_head">Completed</div>
                        <div class="program_name center_head">Time Spent</div>
                        <div class="program_name center_head">Length</div>
                        <div class="program_name center_head">Sections</div>
                        <div class="program_name center_head">Difficulty</div>
                        <div class="program_name center_head">Layers</div>
                        <div class="program_name">Status</div>
                    </div>

                    <div class="right_head">
                        <div class="program_details prog_name"
                            style="height: 32px !important; max-height: 32px !important">The Pathway to Director</div>
                        <div class="program_details date center_col">02/28/23</div>
                        <div class="program_details date center_col">02/30/23</div>
                        <div class="program_details date center_col">2 Days</div>
                        <div class="program_details  center_col">

                            <div class="card_footerIcn">
                                <img src="../../assets/images/Time Circle.svg" alt="">
                            </div>
                            <div class="card_footer_sub_head">
                                6
                            </div>
                        </div>
                        <div class="program_details center_col">
                            <div class="card_footerIcn">
                                <img src="../../assets/images/Category.svg" alt="">
                            </div>
                            <div class="card_footer_sub_head">
                                2
                            </div>
                        </div>
                        <div class="program_details date center_col">
                            <div class="level_easy">
                                <span class="first colored"></span>
                                <span class="second colored"></span>
                                <span class="third transparent"></span>
                            </div>
                        </div>
                        <div class="program_details date center_col">1</div>
                        <div class="program_details complete_col"><span class="completeBtn">Complete</span>
                        </div>
                    </div>
                </div>
            </ng-template>


        </swiper>
    </div> -->




</div>


<div *ngIf="showInProgress">
    <div *ngIf="showInProgress" class="history_container">

        <ng-container *ngFor="let categ of filteredCategoriesForProgress">
            <div
                class="history_table_head blackBgg">
                {{categ.name}}
            </div>

        <swiper [config]="config" [virtual]="true" class="my-swiper">
            <ng-template swiperSlide *ngFor="let program of getInprogressProgramsByCategory(categ.id)">
                <div class="table_content">
                    <div class="left_head">
                        <div class="program_name">Title</div>
                        <div class="program_name center_head">Started</div>
                        <div class="program_name center_head">Completed</div>
                        <div class="program_name center_head">Time Spent</div>
                        <div class="program_name center_head">Length</div>
                        <div class="program_name center_head">Sections</div>
                        <div class="program_name center_head">Difficulty</div>
                        <div class="program_name center_head">Layers</div>
                        <div class="program_name">Status</div>
                    </div>

                    <div class="right_head">
                        <div class="program_details prog_name">{{ program.name }}</div>
                        <div class="program_details date center_col">{{ program.startedAt?.toDate() | date:
                            "MM/dd/yy" }}
                        </div>
                        <div class="program_details date center_col"></div>
                        <div class="program_details date center_col"></div>
                        <div class="program_details center_col">
                            <div class="card_footerIcn">
                                <img src="../../assets/images/Time Circle.svg" alt="">
                            </div>
                            <div class="card_footer_sub_head">
                                {{ getLearningHrs(program.totalLearningHrs) }}
                            </div>

                        </div>
                        <div class="program_details center_col">
                            <div class="card_footerIcn">
                                <img src="../../assets/images/Category.svg" alt="">
                            </div>
                            <div class="card_footer_sub_head">
                                {{ getTotalNumberOfSections(program.sections) }}
                            </div>
                        </div>
                        <div class="program_details date center_col">
                            <div class="level_easy">
                                <span class="first colored"></span>
                                <span class="second colored"></span>
                                <span class="third transparent"></span>
                            </div>
                        </div>
                        <div class="program_details date center_col">1</div>
                        <div class="program_details complete_col">
                            <span class="completeBtn_green">
                                In Progress
                            </span>
                        </div>
                    </div>
                </div>
            </ng-template>







        </swiper>
        </ng-container>

    </div>
</div>